module.exports = [
    { label: 'Den', id: 'den' },
    { label: 'Walk-In Closet', id: 'walkInCloset' },
    { label: 'Tub', id: 'tub' },
    { label: 'Accessibility', id: 'accessibility' },
    { label: 'Balcony', id: 'balcony' },
    { label: 'Pantry', id: 'pantry' },
    { label: 'Terrace', id: 'terrace' },
    { label: 'Storage Room', id: 'storageRoom' },
];